module.exports = __webpack_public_path__ + "img/DSC_0094.f920e810.jpg";